import Image from "next/image";
import Link from "next/link";
import {
  Alert,
  Button,
  Divider,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import GoogleIcon from "@mui/icons-material/Google";

import logo from "../public/assets/images/logo.svg";
import { useEffect, useState } from "react";
import { useRouter } from "next/dist/client/router";
import { useAuth } from "../auth/auth";
import { LoadingButton } from "@mui/lab";

export default function Login({ isSignUp }) {
  const {
    userEmailSignUp,
    userEmailSignIn,
    userGoogleSignIn,
    userFacebookSignIn,
  } = useAuth();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const router = useRouter();

  useEffect(() => {
    if (router.isReady) {
      router.query.email ? setEmail(router.query.email) : null;
    }
  }, [router.isReady, router.query]);

  const onSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    if (isSignUp) {
      return userEmailSignUp(email, password).catch((err) => {
        setLoading(false);
        setError(true);
        console.log(err);
      });
    }

    userEmailSignIn(email, password).catch((err) => {
      setError(true);
      setLoading(false);
    });
  };

  return (
    <div className="flex flex-col w-full max-w-md text-center">
      <div className="w-36 mb-10 mx-auto">
        <Image src={logo} alt="channel" layout="responsive" />
      </div>
      <div className="mb-10 space-y-4">
        <h1>{isSignUp ? "Sign up" : "Sign in"}</h1>
        <span className="block">
          {isSignUp
            ? "Already have a Channel account? "
            : "Don't have a Channel account? "}
          <span className="text-primary hover:underline">
            <Link href={isSignUp ? "/" : "/register"}>
              {isSignUp ? "Sign in" : "Sign up"}
            </Link>
          </span>
        </span>
      </div>

      {error && (
        <Alert severity="error" onClose={() => setError(false)} sx={{ mb: 3 }}>
          {isSignUp
            ? "Email is already registered"
            : "Email or password are incorrect, please enter again"}
        </Alert>
      )}

      <form onSubmit={onSubmit} className="space-y-5">
        <TextField
          label="Email"
          helperText=" "
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          InputLabelProps={{ required: false }}
          InputProps={{ sx: { fontSize: "1.5rem" }, type: "email" }}
        />
        <TextField
          label="Password"
          helperText={isSignUp ? "Minimum 8 characters" : " "}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          InputLabelProps={{ required: false }}
          inputProps={{ minLength: 8 }}
          InputProps={{
            type: show ? "text" : "password",
            sx: { fontSize: "1.5rem" },
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShow(!show)}>
                  {!show ? (
                    <VisibilityOffOutlinedIcon />
                  ) : (
                    <VisibilityOutlinedIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
        <LoadingButton fullWidth loading={loading} type="submit">
          {isSignUp ? "Sign up" : "Sign in"}
        </LoadingButton>
      </form>
      <Divider className="text-sm" sx={{ my: 2 }}>
        Or
      </Divider>
      <div className="pt-4 pb-8 space-y-5">
        <Button
          fullWidth
          variant="outlined"
          startIcon={<GoogleIcon />}
          onClick={userGoogleSignIn}
        >
          Connect with Google
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<FacebookOutlinedIcon />}
          onClick={userFacebookSignIn}
        >
          Connect with Facebook
        </Button>
      </div>
      <span className="font-medium text-sm mb-10 hover:text-primary">
        <Link href="/reset-password">Forgot password?</Link>
      </span>
      <div className="text-xs">
        By signing up you agree to Channel’s{" "}
        <span className="text-primary">Terms of service</span> and{" "}
        <span className="text-primary">Privacy policy</span>.
      </div>
    </div>
  );
}
